<template>
	<v-container>
		<v-row v-if="iFramesList" justify="center">
			<v-col md="6">
				<v-row>
					<v-col v-for="(dashboard, index) in iFramesList" :key="index" md="6" cols="12">
						<v-card @click="selectDashboard(dashboard.id)" class="dashboard">
							<v-card-title v-text="$t(`BPM.${dashboard.clientId}.${dashboard.id}.title`)"></v-card-title>
							<v-card-subtitle>{{ $t(`BPM.${dashboard.clientId}.${dashboard.id}.description`)}}</v-card-subtitle>
							<v-icon class="goto">mdi-chevron-right</v-icon>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
		</v-row>
	</v-container>

</template>


<script>

import { api } from '@/utils/api';


export default {
	data () {
		return {
			iFramesList: []
		};
	},
	methods: {
		selectDashboard (id) {
			this.$store.commit('setDashboardId', id);
			this.$router.push(`/${this.$store.getters.getClientName}/BPM/${id}`);
		},
		async getIFrames () {
			this.iFramesList = await api.get('iframesBPM', { clientId: this.$store.getters.getCurrentClientId });
			this.$store.commit('setDashboards', this.iFramesList);
			if (this.iFramesList.length === 1) {
				this.selectDashboard(this.iFramesList[0].id);
			}
		}
	},
	async mounted () {
		if (this.$store.getters.getCurrentClientId) {
			await this.getIFrames();
		}
	},
	watch: {
		async '$store.getters.getCurrentClientId' () {
			await this.getIFrames();
		}
	}
};

</script>
<style lang="scss" scoped>

@import "@/scss/_colors.scss";

.dashboard {
	cursor: pointer;
	border-top: 7px solid #fff;
	.v-card__subtitle {
		padding-bottom: 42px;
	}
	.goto {
		color: $primary;
		border-radius: 50% !important;
		position: absolute;
		right: 10px;
		bottom: 20px;
	}
	&:hover {
		border-top: 7px solid $primary;
		.goto {
			background-color: $primary;
			color: #fff;
		}
	}
}
</style>
